import React, { useState, useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import SignInIcon from "@mui/icons-material/Input";

import loginClasses from "../Login/Login.module.css";
import { useUnlockAccountFromTokenMutation } from "../../api/auth.api.slice";
import LocalLoader from "../../components/Loaders/Local";

function UnlockAccountFromTokenPage() {
  const [searchParams] = useSearchParams();
  const unlockToken = searchParams.get("unlockToken");
  const [notification, setNotification] = useState({
    message: "",
    success: false,
    error: false,
  });

  const [unlockAccountFromToken, { isLoading }] =
    useUnlockAccountFromTokenMutation();

  const { success, error, message } = notification;

  useEffect(() => {
    const unlockAccount = async () => {
      if (!unlockToken) {
        setNotification({
          error: true,
          success: false,
          message: "Invalid or missing unlock token.",
        });
        return;
      }

      try {
        const data = await unlockAccountFromToken({
          unlockToken,
        }).unwrap();
        if (data) {
          const msg =
            data.message ||
            "Your account has been unlocked successfully. Please login.";
          setNotification({ error: false, success: true, message: msg });
        }
      } catch (err) {
        const errorMsg =
          err?.data?.message ||
          "Failed to unlock account. The link may be invalid or expired.";
        setNotification({ error: true, success: false, message: errorMsg });
      }
    };

    unlockAccount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unlockToken]);

  return (
    <div>
      <Grid
        container
        direction="row"
        className={loginClasses.loginGrid}
        sx={{ justifyContent: "center", alignItems: "center" }}
      >
        <Grid size={{ xs: 11, sm: 8, md: 5 }}>
          <Card raised>
            <CardHeader
              title="Unlock Account"
              className={loginClasses.cardHeader}
            >
              Unlock Account
            </CardHeader>

            {(success || error) && (
              <CardContent sx={{ textAlign: "center" }}>
                {success && (
                  <Button
                    variant="contained"
                    component={Link}
                    to="/login"
                    sx={{ my: 1 }}
                  >
                    <SignInIcon sx={{ mr: 0.75 }} />
                    Sign In
                  </Button>
                )}
                {error && (
                  <Button
                    variant="contained"
                    component={Link}
                    to="/unlockAccount"
                    sx={{ my: 1 }}
                  >
                    Request New Unlock Link
                  </Button>
                )}
                <Typography color={success ? "primary" : "error"}>
                  {message}
                </Typography>
              </CardContent>
            )}

            {isLoading && !(success || error) && (
              <CardContent sx={{ textAlign: "center", minHeight: "5rem" }}>
                <LocalLoader progress={isLoading} />
              </CardContent>
            )}
          </Card>
        </Grid>
      </Grid>
    </div>
  );
}
export default UnlockAccountFromTokenPage;
